import Box from '@eversports/klimt-primitives/legacy/Box'
import * as React from 'react'

interface ClickableProps {
  isDisabled?: boolean
  onClick?: () => void
  ariaLabel: string
}

const IconBadge: React.FC<React.PropsWithChildren<ClickableProps>> = ({
  children,
  onClick,
  ariaLabel,
  isDisabled = false,
}) => {
  return (
    <Box
      component="button"
      aria-label={ariaLabel}
      sx={{
        padding: 2,
        background: '#FFFFFF',
        border: '0.5px solid',
        borderColor: 'lightgray',
        boxSizing: 'border-box',
        boxShadow: '0px 1px 2px #DDDDDD',
        borderRadius: 80,
        cursor: isDisabled ? 'default' : 'pointer',
        backgroundColor: isDisabled ? 'lightgray' : 'white',
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  )
}

export default IconBadge
